import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const risingStars = [{
  id: 1,
  name: "Landscape Design",
  role: "Artistic Vision",
  bio: "Transforming outdoor spaces into living masterpieces. Our design process integrates native flora with architectural elements to create sustainable, breathtaking environments tailored to your lifestyle.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668432/img/landscape_design_masterpiece.png",
  link: "/OurCraftPage"
}, {
  id: 2,
  name: "Custom Patios",
  role: "Outdoor Living",
  bio: "Expertly crafted stone and paver installations that extend your home's comfort to the outdoors. We specialize in durable, elegant surfaces perfect for entertaining or quiet relaxation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668432/img/custom_patio_stonework.png",
  link: "/OurCraftPage"
}, {
  id: 3,
  name: "Irrigation Systems",
  role: "Precision Care",
  bio: "Smart water management solutions that keep your landscape thriving while conserving resources. Our advanced repair and maintenance services ensure peak performance year-round.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668432/img/irrigation_system_maintenance.png",
  link: "/SeasonalCarePage"
}];
export default function PerfisEmAscensao() {
  return <section data-section-id="223496" id="design-build-services" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-2xl">
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary md:text-5xl">
            Design & Build Services
          </h2>
          <p className="mt-4 text-lg text-muted-foreground font-default">
            From initial concept to final installation, Campos V Landscaping delivers organic precision in every detail of your outdoor sanctuary.
          </p>
        </div>

        <div className="flex h-[1200px] w-full flex-col gap-4 lg:h-[700px] lg:flex-row">
          {risingStars.map((star, i) => <div key={star.id} data-index={i} className="group relative flex flex-1 cursor-pointer flex-col overflow-hidden rounded-lg bg-card shadow-md transition-all duration-700 ease-in-out hover:flex-[2] lg:hover:flex-[2.5] hover:shadow-xl">
              {}
              <img src={star.image} alt={`Professional ${star.name} service`} className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" />

              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/40 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-95" />

              {}
              <div className="relative mt-auto flex flex-col justify-end p-6 md:p-8">
                <span className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-ring">
                  {star.role}
                </span>
                
                <h3 className="font-serif text-3xl font-bold leading-none text-primary-foreground md:text-4xl lg:text-5xl">
                  {star.name}
                </h3>

                {}
                <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:grid-rows-[1fr]">
                  <div className="overflow-hidden">
                    <p className="font-default mt-4 text-sm leading-relaxed text-primary-foreground/80 md:text-base">
                      {star.bio}
                    </p>
                    
                    <div className="mt-6 opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                      <Button asChild variant="outline" className="group/btn border-primary-foreground/50 bg-transparent text-primary-foreground hover:bg-primary-foreground hover:text-primary rounded-lg">
                        <Link to={star.link}>
                          Explore Service
                          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}